export const formats = {
    date_format: "DD/MM/YYYY",
    time_format: "hh:mm a",
    date_time_format: "DD/MM/YYYY hh:mm a",
    free_subscription_format: "Do MMM, YYYY",
    plan_subscription_format: "DD MMMM YYYY",
    date_cme_format: "DD",
    month_year_format: "MMMM YYYY",
    paymentHistory:"DD-MMM YYYY"
}
